export default function (query) {
  return `market=${query.market}&resolution=${query.resolution}&from=${query.from}&to=${query.to}`;
}
